module.exports = __webpack_public_path__ + "img/16_mark_n.36b55a2e.png";